<template>
	<div class="faa-loader" v-if="show">
		<span></span>
		<span></span>
		<span></span>
		<span></span>
	</div>
</template>

<script>
	export default {
		name: 'TheLoader',
		data() {
			return {
				show: true
			}
		},
		mounted() {
			// Always hide it after 10s to improve perf
			setTimeout(() => {
				this.show = false
			}, 10000);
		},
	}
</script>

<style lang="scss" scoped></style>
